import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  environment: import.meta.env.VITE_SENTRY_ENVIRONMENT,
  enabled: import.meta.env.MODE !== 'development',
  _experiments: {
    enableLogs: true,
  },
  transport: Sentry.makeBrowserOfflineTransport(Sentry.makeFetchTransport),
  integrations: [
    // new Sentry.browserTracingIntegration({
    //   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    //   // TODO: need to narrow down the tracePropagationTargets to specific URLs or origins that your application interacts with, rather than allowing tracing for all URLs.
    //   tracePropagationTargets: ['*'],
    // }),
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: false,
    }),
    // Sentry.feedbackIntegration({
    //   colorScheme: 'system',
    //   showBranding: false,
    //   isEmailRequired: true,
    //   isNameRequired: true,
    // }),
  ],

  tracesSampleRate: 1, //  Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.25, // This sets the sample rate at 15%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});

export default Sentry;
